import { useStore } from 'store';
import getFileMap from './getFileMap';

export default function useFileMap() {
  return useStore(getFileMap);
}
